import DrawService from "./DrawService";

const ShowService = {  
  
    addEntitesToMap(geoJson,action) {
        let promises = [];
    
        let contenu  = {
            marker: 0,
            circle:{
                nb: 0,
                surface :0
            },
            polygon:{
                nb: 0,
                surface :0
            },
            polyline:{
                nb: 0,
                distance :0
            },
            rectangle:{
                nb: 0,
                surface :0
            }
        }

        let i = 0;
        L.geoJson(geoJson, {
            onEachFeature: (featureparam, layer) => {
                let feature;
                
                const descriptor = Object.getOwnPropertyDescriptor(featureparam.properties, 'options');
                if(descriptor.writable){
                    feature = featureparam;
                }else{
                    feature = JSON.parse(JSON.stringify(featureparam));
                }
                i++;
                if(this.isJsonString(feature.properties.options)) {
                    feature.properties.options = JSON.parse(feature.properties.options);
                }
                
                let p = null;
                switch (feature.properties.type) {
                    case "marker":
                            contenu.marker++;
                            const addingMarker = new L.Marker(layer.getLatLng(),{ 
                                icon:this.createExtraMarker(feature.properties.options.icon.options)
                            });
                           p = DrawService.AddLayerCollection(addingMarker,feature.properties,action);
                            break;
                    case "circle":
                            contenu.circle.nb++;
                            contenu.circle.surface += this.circleArea(layer.feature.properties.options.radius);
                            const addingcircle = new L.Circle(layer.getLatLng(), feature.properties.options);                            
                            p = DrawService.AddLayerCollection(addingcircle,feature.properties,action);
                        break;
                    case "polyline":
                            contenu.polyline.nb++;
                            contenu.polyline.distance += this.lineDistance(layer.getLatLngs());
                            const addingpolyline = new L.Polyline(layer.getLatLngs(), feature.properties.options);                          
                            p = DrawService.AddLayerCollection(addingpolyline,feature.properties,action);
                        break;
                    case "polygon":
                            contenu.polygon.nb++;
                            contenu.polygon.surface += + this.ringArea(layer.getLatLngs());
                            const addingpolydon = new L.Polygon(layer.getLatLngs(), feature.properties.options);                        
                            p = DrawService.AddLayerCollection(addingpolydon,feature.properties,action);
                        break;
                    case "rectangle":
                            contenu.rectangle.nb++;
                            contenu.rectangle.surface += this.ringArea(layer.getLatLngs());
                            const addingrectangle = new L.Polygon(layer.getLatLngs(), feature.properties.options);                        
                            p = DrawService.AddLayerCollection(addingrectangle,feature.properties,action);
                        break;
                }
                if (p) promises.push(p); // stocke la promesse
            }
        });
        return Promise.all(promises); // retourne toutes les couches ajoutées
    },

    isJsonString(str) {
        if (typeof str !== 'string') return false;
        try {
          JSON.parse(str);
          return true;
        } catch (e) {
          return false;
        }
    },

    createTextMarker({ texte = "Texte", css = {} }) {
        const span = `<span style="margin-top:0px;margin-bottom:0px;width:max-content;display:inline-block;white-space:nowrap;${this.objectToInlineStyle(css)}">${texte}</span>`;
        
        return L.divIcon({
            className: "text-labels",
            html: span
        });
    },

    objectToInlineStyle(styleObj) {
        if (!styleObj || typeof styleObj !== "object") return "";
        return Object.entries(styleObj)
            .map(([key, value]) => `${this.camelToKebab(key)}:${value}`)
            .join(";");
    },
    
    camelToKebab(str) {
        return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    },

    createExtraMarker({icon = "fa-circle", markerColor = "#252525", iconColor = "#ffffff", shape = "circle", prefix = "fa", svg = true}){
        if(icon == " " || icon == "") icon = "fa-circle";
        return L.ExtraMarkers.icon({
            icon: icon,
            markerColor: markerColor,
            iconColor: iconColor,
            shape: shape,
            prefix: prefix,
            svg:svg
        });
    },
    
    lineDistance(coords){
        var dist,totalDist = 0;
        var ll1,ll2;
        if (coords && coords.length && Array.isArray(coords[0])) {
            coords = coords[0];
        }
        if (coords.length > 1) {
            for (var i = 1, len = coords.length;  i < len; i++) {
                ll1 = coords[i - 1];
                ll2 = coords[i % len];
                dist = ll1.distanceTo(ll2);
                totalDist += dist;
            }
        }
        return totalDist;
    },

    circleArea(RADIUS) {
        return Math.PI * RADIUS * RADIUS;
    },

    ringArea(coords) {
        if (coords && coords.length && Array.isArray(coords[0])) {
            coords = coords[0];
        }
        var RADIUS = 6378137;
        var rad = function rad(_) {
            return _ * Math.PI / 180;
        };
        var p1, p2, p3, lowerIndex, middleIndex, upperIndex,
        area = 0,
        coordsLength = coords.length;

        if (coordsLength > 2) {
            for (var i = 0; i < coordsLength; i++) {
                if (i === coordsLength - 2) {// i = N-2
                    lowerIndex = coordsLength - 2;
                    middleIndex = coordsLength -1;
                    upperIndex = 0;
                } else if (i === coordsLength - 1) {// i = N-1
                    lowerIndex = coordsLength - 1;
                    middleIndex = 0;
                    upperIndex = 1;
                } else { // i = 0 to N-3
                    lowerIndex = i;
                    middleIndex = i+1;
                    upperIndex = i+2;
                }
                p1 = coords[lowerIndex];
                p2 = coords[middleIndex];
                p3 = coords[upperIndex];
                area += ( rad(p3.lng) - rad(p1.lng) ) * Math.sin( rad(p2.lat));
            }

            area = area * RADIUS * RADIUS / 2;
        }
        return Math.abs(area);
    },

    

  
  }
  
  export default ShowService;